import "../sellscreendialogs.scss";
import { type FC, useCallback, useState } from "react";
import { TouchNumbers } from "@onshopfront/components";
import { useShopfrontDispatch } from "../../../../_Bootstrap/hooks";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import { type SaleAddGiftCardOptions } from "../../../../Actions/SellScreen/SellScreenProductActions";
import { addGiftCardToSale } from "../../../../Actions/SellScreen/SellScreenProductActions";
import Button from "../../../../Common/Buttons/Button";
import PopupManager from "../../../../Common/Popups/PopupManager";
import { currency, getCurrencyDecimalPlaces } from "../../../../Utilities/Generic/Numbers";

export const RequestAmount: FC<SaleAddGiftCardOptions> = (options) => {
    const [ value, setValue ] = useState<number | null>(null);
    const dispatch = useShopfrontDispatch();
    const addAmount = useCallback((validateAmount = false) => {
        if(value === null) {
            PopupManager.error("Invalid gift card amount provided");

            return;
        }

        if(validateAmount && value > 9999) {
            PopupManager.create({
                message: `To create a gift card with a value of ${currency(value)}, please click Add`,
                icon   : "exclamation",
                classes: [ "popup-warning" ],
                timeout: 10000,
            });

            return;
        }

        if(value <= 0) {
            PopupManager.error("The gift card amount must be greater than zero");

            return;
        }

        dispatch(hideDialog());
        dispatch(addGiftCardToSale({
            ...options,
            amount: value,
        }));
    }, [ dispatch, options, value ]);

    return (
        <div className="request-amount">
            <p>Please enter the gift card&apos;s value</p>
            <TouchNumbers
                mode="numeric"
                input="currency"
                value={value}
                onChange={setValue}
                min={0}
                decimalPlaces={getCurrencyDecimalPlaces()}
                onKeyDown={e => {
                    if(e.key === "Enter") {
                        addAmount(true);

                        e.preventDefault();
                        e.stopPropagation();
                    }
                }}
                autoFocus
            />
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-cancel" ]}
                    onClick={() => dispatch(hideDialog())}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    classes={[ "button-save" ]}
                    onClick={() => addAmount()}
                >
                    Add
                </Button>
            </div>
        </div>
    );
};
